export const FIND_PRODUCTS_BY_ID_CATEGORY = "FIND_PRODUCTS_BY_ID_CATEGORY"
export const FIND_PRODUCTS_BY_ID_CATEGORY_SUCCESS = "FIND_PRODUCTS_BY_ID_CATEGORY_SUCCESS"

export const FIND_PRODUCTS_BY_ID_CATEGORY_API_ERROR = "FIND_PRODUCTS_BY_ID_CATEGORY_API_ERROR"
